"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _result = _interopRequireDefault(require("./result"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var _default = exports["default"] = function _default(client) {
  return function (query) {
    return client.transfers.find(query).then(_result["default"]);
  };
};
module.exports = exports["default"];